import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {isEmpty} from 'lodash';

import Utility from '../../../../util/utilityfunctions';
import {labels} from '../../../../util/utils';

import {BarChart} from '@ey/canvascoreservices/Charts';
import OutputText from '@ey/canvascoreservices/OutputText';

import Tile from '../../Tile';
import StyledCount from './StyledCount';

const SummaryBarChart = ({
	title,
	secondTitle,
	count,
	subtitle,
	chartsConfig,
	noDataTitle,
	noDataSubtitle,
	footer,
	numberFormat,
	onGraphicClick,
	onOverdueClick
}) => {
	const renderCount = (count, label, onClick = null) => {
		const props = {};
		if (onClick) props.onClick = onClick;
		return (
			<StyledCount>
				<OutputText h3 title={count}>
					{count}
				</OutputText>
				<OutputText body3 title={label} className={classNames('grey', {clickable: !!onClick})} {...props}>
					{label}
				</OutputText>
			</StyledCount>
		);
	};

	const renderChart = (chartData) => {
		const {headerText, ...rest} = chartData;
		const props = {
			chartType: 'barChart',
			chartData: rest,
			theme: document.getElementsByTagName('body')[0].getAttribute('motif-theme') === 'dark' ? 'dark' : null,
			onGraphicClick: (e) => {
				const serie = e.point.series.userOptions.toolTip.split('|')?.[0]?.trim() || '';
				onGraphicClick(serie);
			},
			onOverdueClick: onOverdueClick,
			serieSuffix: ` ${labels.overdue}`
		};

		return (
			<>
				<OutputText body2>{headerText}</OutputText>
				<BarChart {...props} />
			</>
		);
	};

	const tileProps = {
		title: title,
		subTitle: secondTitle,
		isEmpty: !(count > 0),
		emptyTitle: noDataTitle,
		emptySubtitle: noDataSubtitle
	};

	return (
		<Tile {...tileProps}>
			{renderCount(Utility.getFormattedNumber(numberFormat, count), subtitle)}
			{!isEmpty(chartsConfig) && chartsConfig.map(renderChart)}
			{footer && renderCount(...footer)}
		</Tile>
	);
};

SummaryBarChart.propTypes = {
	title: PropTypes.string,
	secondTitle: PropTypes.string,
	subtitle: PropTypes.string,
	count: PropTypes.number,
	noDataTitle: PropTypes.string,
	noDataSubtitle: PropTypes.string,
	footer: PropTypes.element,
	chartsConfig: PropTypes.arrayOf(
		PropTypes.shape({
			barStyling: PropTypes.shape({
				chartWidth: PropTypes.number,
				styleName: PropTypes.string,
				chartWrapper: PropTypes.string,
				tooltipBorderColor: PropTypes.string,
				tooltipBackground: PropTypes.string,
				styleBarcountClass: PropTypes.string
			}),
			headerText: PropTypes.string,
			barMaxValue: PropTypes.number,
			showBarTitleTip: PropTypes.bool,
			barItems: PropTypes.arrayOf(
				PropTypes.shape({
					count: PropTypes.number,
					label: PropTypes.string,
					statusClass: PropTypes.string,
					color: PropTypes.string,
					warningMessage: PropTypes.string,
					toolTip: PropTypes.string
				})
			)
		})
	),
	onGraphicClick: PropTypes.func,
	onOverdueClick: PropTypes.func
};

export default SummaryBarChart;
